import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { WarehouseDataType } from "../../../../interfaces/admin.interface";
import { WarehouseService } from "../../../../services/warehouse.service";

interface WarehouseSelectProps {
  setFieldValue: (field: string, value: any) => void;
  warehouse_id: number | null;
  selectedName: string | undefined;
  setSelectedName: (value: string | undefined) => void;
}

const SelectWarehouse: React.FC<WarehouseSelectProps> = ({
  setFieldValue,
  warehouse_id,
  selectedName,
  setSelectedName,
}) => {
  const [warehouse, setWarehouse] = useState<WarehouseDataType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true);
    WarehouseService.getAllwarehouse()
      .then((response) => {
        setWarehouse(response?.data?.data);
        const selectedWarehouse = response?.data?.data?.find(
          (element: WarehouseDataType) => element.id === warehouse_id
        );
        setSelectedName(selectedWarehouse?.warehouse_name);
      })
      .finally(() => setLoading(false));
  }, [warehouse_id, setSelectedName]);

  return (
    <Select
      style={{ width: "100%", height: "46px" }}
      placeholder={loading ? "Anbarlar yüklənir..." : "Anbar seçin"}
      options={warehouse?.map((element) => ({
        label: element.warehouse_name,
        value: element.warehouse_name,
      }))}
      value={selectedName}
      onChange={(newName) => {
        setSelectedName(newName);
        const selectedWarehouse = warehouse.find(
          (element) => element.warehouse_name === newName
        );
        if (selectedWarehouse) {
          setFieldValue("warehouse_id", selectedWarehouse.id);
        }
      }}
    />
  );
};

export default SelectWarehouse;
